import { Component } from "react"
import routes from "../../routes/URL"
import API, { URL_PATH } from "../../services/API"
import Header from "../../components/Header"
import redux from "../../common/Redux"
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  TextField,
  Button,
  FormControlLabel,
  Switch,
  Card,
  CardHeader,
  CardContent,
  Grid,
} from "@mui/material"
import Toast from "../../components/Toast"
class ListMenuScreen extends Component {
  constructor(props) {
    super(props)
    this.state = { data: null, active: "details", permissions: [], toast: {
      open: false,
      message: "",
      severity: "success" // default severity
    } }
  }

  componentDidMount() {
     const hotel = this.props.hotels.find(h => h.hotel_slug === this.props.match.params.hotelSlug);
        if (!hotel) {
            this.props.history.push(routes.admin.dashboard.root(this.props.hotels[0]?.hotel_slug || ''));
            return;
        }
    this.getUserData()
    this.getAllAvailablePermissions()
    if (this.props.match.params.action == "permissions") {
      this.setState({ active: "permissions" })
    }
  }
  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity
      }
    });
  };

  handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false
      }
    });
  };

  getAllAvailablePermissions = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getAllAvailablePermissions)
    if (status == "success") {
      this.setState({ permissions: data })
    } else {
      this.showToast(message, "error");
 
    }
  }

  getUserData = async () => {
    const { status, message, data } = await API(this, "get", URL_PATH.getUserData(this.props.match.params.id))
    if (status == "success") {
     

      this.setState({ data })
    } else {
      this.showToast(message, "error");
    }
  }



  onDelete = async (item) => {
    console.log("sure to delete?")
    const { status, message, data } = await API(this, "post", URL_PATH.deleteMenu(item.id))
    if (status == "success") {
      // Show success toast
      this.showToast(message, "success");
      
      // Execute state update immediately (no need for callback)
      this.setState({
        version: this.state.version + Math.random() + "",
      });
    } else {
      // Show error toast and log error
      this.showToast(message, "error");
      console.log("error");
    }
  }

  update = async () => {
    const { name, mobile, email ,designation} = this.state.data;
  
    const payload = {
      name,
      mobile,
      email,
      designation
    };
  
    const { status, message } = await API(
      this,
      "post",
      URL_PATH.updateUser(this.props.match.params.id), // should resolve to /hotelowner/user/updatestaff/:id
      payload
    );
  
    if (status === "success") {
      this.setState({
        toast: {
          open: true,
          message,
          severity: "success"
        }
      });
      setTimeout(() => {
        this.props.history.push(routes.admin.users.root);
      }, 2000);
    } else {
      this.setState({
        toast: {
          open: true,
          message,
          severity: "error"
        }
      });
    }
  };
  

  onEdit = async (item) => {
    this.props.history.push(routes.admin.users.update(this.props.hotels[0].hotel_slug,item.slug,item.id));
  }

  onView = async (item) => {
    // this.props.history.push("/floors/" + item.id);
  }

  updateAccess = async (access_controll_id, action) => {
    const user_id = this.props.match.params.id
    const { status, message, data } = await API(this, "post", URL_PATH.updateUserAccessControl, {
      user_id,
      access_controll_id,
      action,
    })

    if (status == "error")
      this.showToast(message, "error");
     
  }

  UserDetails = () => {
    if (this.state.data == null) return null

    const { id, name, mobile, email,designation} = this.state.data

    return (
      <Card sx={{ mt: 3,backgroundColor:"#02111B", backgroundImage:"none",border:"1px solid #FFC857" }}>
        <CardHeader title="User Details" />
        <CardContent>
          <form
            id="hotelForm"
            name="hotelForm"
            onSubmit={(e) => {
              e.preventDefault()
              return this.update()
            }}
          >
            <TextField
              fullWidth
              margin="normal"
              label="Name"
              value={name}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    name: e.target.value,
                  },
                })
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Mobile"
              value={mobile}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    mobile: e.target.value,
                  },
                })
              }}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Email"
              value={email}
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                    email: e.target.value,
                  },
                })
              }}
            />
              <TextField
              fullWidth
              margin="normal"
              label="Designation"
              value={designation }
              onChange={(e) => {
                this.setState({
                  data: {
                    ...this.state.data,
                   designation : e.target.value,
                  },
                })
              }}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                mt: 3,
                bgcolor: "#FFC857",
                fontWeight:"700",
                "&:hover": { bgcolor: "#E6B54E" },
              }}
            >
              Update
            </Button>
          </form>
        </CardContent>
      </Card>
    )
  }

  UserPermissions = () => {
    if (this.state.data == null) return null
    const { access_controls } = this.state.data
    const { permissions } = this.state

    return (
      <Card sx={{ mt: 3,backgroundColor:"#02111B", backgroundImage:"none",border:"1px solid #FFC857" }}>
        <CardHeader title="User Permissions" />
        <CardContent>
          <Grid container spacing={2}>
            {permissions.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={access_controls.find((x) => x.id == item.id) != undefined}
                      onChange={(e) => {
                        const newValue = e.target.checked
                        if (newValue) {
                          this.setState({
                            data: {
                              ...this.state.data,
                              access_controls: [
                                ...this.state.data.access_controls,
                                {
                                  id: item.id,
                                },
                              ],
                            },
                          })
                        } else {
                          this.setState({
                            data: {
                              ...this.state.data,
                              access_controls: this.state.data.access_controls.filter((x) => x.id != item.id),
                            },
                          })
                        }
                        this.updateAccess(item.id, newValue ? "grant" : "revoke")
                      }}
                    />
                  }
                  label={item.name.replace("-", " ")}
                />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    )
  }

  render() {
    return (
      <>
      

      <Container maxWidth="lg">
                      <Header title="Customers" />

        <Tabs
          value={this.state.active}
          onChange={(event, newValue) => {
            this.setState({ active: newValue })
          }}
          sx={{ mb: 3 }}
        >
          <Tab label="Details" value="details" />
          <Tab label="Permissions" value="permissions" />
        </Tabs>

        {this.state.active === "details" && <this.UserDetails />}
        {this.state.active === "permissions" && <this.UserPermissions />}
      </Container>

      </>
    )
  }
}

export default redux(ListMenuScreen)

